import { useEffect, useRef } from 'react';
import { useLocation } from 'react-router-dom';
import { authApi } from 'api/auth';
import { getSessionId } from '../utils/session-storage';

const PageTracker: React.FC = () => {
  const location = useLocation();
  const lastSent = useRef<string>('');

  useEffect(() => {
    const path = location.pathname || '/';
    if (path === lastSent.current) return;
    lastSent.current = path;
    if (!localStorage.getItem('accessToken')) return;

    authApi.trackPage(path, getSessionId()).catch(() => {
      /* nu blocăm UI-ul dacă logul de pagină eșuează */
    });
  }, [location.pathname]);

  return null;
};

export default PageTracker;
